import { useParams } from 'react-router-dom';
import { Loader } from 'legacy-components/componets';
import { useOfferDetails } from 'hooks/query';
import ApplicationSummaryContainer from './components/ApplicationSummaryContainer';
import TenantScreeningSection from '../background-check/components/TenantScreeningSection';
import { extractOrderPlanLocation } from 'components/molecules/ScreeningServicePlan/helpers/extract-order-plan-location';

const ApplicationSummary = () => {
  const { applicationId = '' } = useParams<{ applicationId: string }>();
  const { data: offerDetails, isLoading: isOfferDetailsLoading } = useOfferDetails(applicationId);

  if (isOfferDetailsLoading) {
    return <Loader />;
  }

  return (
    <ApplicationSummaryContainer applicationId={applicationId} offerDetails={offerDetails}>
      <TenantScreeningSection 
        renterId={offerDetails?.renterId || ''} 
        applicationId={offerDetails?.id || ''} 
        offerStatus={offerDetails?.status} 
        location={extractOrderPlanLocation(offerDetails?.location)} 
      />
    </ApplicationSummaryContainer>
  );
};

export { ApplicationSummary };
